import { createFileRoute } from '@tanstack/react-router'

import {
  listSearchValidator,
  useListFilters,
} from '@/components/Internal/DataTable'
import { bankListFilters } from '@/components/Internal/Finance/Bank/bank-list-filters'
import { BankOverview } from '@/components/Internal/Finance/Bank/BankOverview'
import { BankTransactionsTable } from '@/components/Internal/Finance/Bank/BankTransactionsTable'

export const Route = createFileRoute('/internal/system/administration/bank')({
  validateSearch: listSearchValidator(bankListFilters),
  component: BankScreen,
})

function BankScreen() {
  const filters = useListFilters(bankListFilters, Route)
  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <BankOverview />
      <BankTransactionsTable filters={filters} />
    </div>
  )
}
